import type { EduSchool } from '@common/types/edu-course.type';
import type { EduSchoolsCollectionState } from './edu-schools.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';

import { EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY, eduSchoolsAdapter } from './edu-schools.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollection, selectCollectionStatuses } = eduSchoolsAdapter.getSelectors();

const selectEduSchoolsState = createSelector(
    collectionsState,
    (state: CollectionsState): EduSchoolsCollectionState => state[EDU_SCHOOLS_COLLECTIONS_FEATURE_KEY]
);

export const selectEduSchools = createSelector(selectEduSchoolsState, selectCollection);

export const selectIsEduSchoolsEmpty = createSelector(
    selectEduSchools,
    (eduSchools: EduSchool[]): boolean => !eduSchools || eduSchools?.length === 0
);

export const selectEduSchoolsStatuses = createSelector(selectEduSchoolsState, selectCollectionStatuses);

export const selectEduSchoolsBySiteId = (siteId: string) =>
    createSelector(selectEduSchools, (eduSchools: EduSchool[]) =>
        eduSchools.filter((school: EduSchool) => school?.landingId?.toString() === siteId)
    );
